import { Fragment, useState, useEffect } from "react";
import { PanelBody, PanelRow, TextControl, RadioControl, RangeControl, SelectControl, ToggleControl, __experimentalUnitControl as UnitControl } from "@wordpress/components";
const { __ } = wp.i18n;
import { produce } from "immer";

import BColor from "../../BColor";
import BMediaUpload from "../../BMediaUpload";
import BControlPro from "../../../../components/BControlPro";

const Overlay = ({ attributes, handleFeatures, isPremium }) => {
  const { enabled, items } = attributes.features.overlay;
  const [index] = useState(0);
  const { color, backgroundColor, fontSize, link, logo, text, position, type, opacity } = items[index] || {};

  console.log({ type });

  const handleOverlay = (value) => {
    handleFeatures(
      produce(attributes.features.overlay, (draft) => {
        draft.enabled = enabled;
        Object.keys(value).map((key) => {
          draft.items[index][key] = value[key];
        });
      }),
      "overlay"
    );
  };

  return (
    <PanelBody title={__("Overlay", "h5vp")} initialOpen={false}>
      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        id="overlay"
        label={__("Overlay", "h5vp")}
        checked={enabled}
        onChange={() => handleFeatures({ enabled: !enabled }, "overlay")}
      />

      {enabled && (
        <Fragment>
          {/* <ToggleControl id="overlayTypeText" label={__("Text", "h5vp")} checked={type === "text"} onChange={() => handleOverlay({ type: "text" })} />

          <ToggleControl label={__("Logo", "h5vp")} id="overlayTypeLogo" checked={type === "logo"} onChange={() => handleOverlay({ type: "logo" })} /> */}

          <SelectControl
            label={__("Type", "h5vp")}
            value={type}
            options={[
              { label: "Text", value: "text" },
              { label: "Logo", value: "logo" },
            ]}
            onChange={(type) => handleOverlay({ type })}
            labelPosition="side"
          />

          <SelectControl
            label={__("Overlay Position", "h5vp")}
            value={position}
            options={[
              { label: "Top Right", value: "top_right" },
              { label: "Top Left", value: "top_left" },
            ]}
            onChange={(value) => handleOverlay({ position: value })}
            labelPosition="side"
          />

          {type === "text" && <TextControl label={__("Text", "h5vp")} value={text} onChange={(text) => handleOverlay({ text })} />}

          {type === "logo" && (
            <>
              <label>{__("Logo", "h5vp")}</label>
              <BMediaUpload label={__("Logo", "h5vp")} type={["image/jpeg"]} onSelect={(logo) => handleOverlay({ logo })} value={logo} />
            </>
          )}

          <TextControl label={__("Link", "h5vp")} value={link} onChange={(link) => handleOverlay({ link })} />

          {type === "text" && (
            <Fragment>
              <UnitControl label={__("Font Size", "h5vp")} value={fontSize} onChange={(fontSize) => handleOverlay({ fontSize })} />

              <BColor label={__("Color", "h5vp")} defaultColor="#ffffff" value={color} onChange={(color) => handleOverlay({ color })} />

              <BColor label={__("Background Color", "h5vp")} defaultColor="#333" value={backgroundColor} onChange={(c) => handleOverlay({ backgroundColor: c })} />
            </Fragment>
          )}
          <RangeControl label="Opacity" value={opacity} onChange={(value) => handleOverlay({ opacity: parseFloat(value) })} min={0.01} max={1} step={0.01} />
        </Fragment>
      )}
    </PanelBody>
  );
};

export default Overlay;
